// extracted by mini-css-extract-plugin
export default {"input":"BottomBarRadioItem_input__0x6As","label":"BottomBarRadioItem_label__Peo7p"};